import { Document, PDFViewer } from '@react-pdf/renderer';
import styled from 'styled-components';

export const ContainerViewer = styled(PDFViewer)`
  width: 100%;
  height: 76vh;
`;

export const ContainerDocument = styled(Document)``;
